export const ChildrenUpperOrLower = ({
  children,
  visible,
}: {
  children: React.ReactNode
  visible: boolean
}) => {
  if (!children) return null

  return (
    <div
      css={{
        display: visible ? 'block' : 'none',
        width: '100%',
      }}
    >
      {children}
    </div>
  )
}
